import {
  detachLayoutProps,
  WSElement,
  WSList,
  WSMarginProps,
  WSPanel,
  WSPill,
  WSPillProps,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces";
import {
  REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY,
  REVIEW_STRATEGY_NEVER_REQUIRED_COPY,
  REVIEW_STRATEGY_ON_FAIL_COPY
} from "../CreateRequirementDefinitionForm/utils";

type Props = {
  reviewStrategy: RequirementReviewStrategy | undefined;
} & WSMarginProps;

export const ApprovalWidget: React.FC<Props> = ({
  reviewStrategy = RequirementReviewStrategy.NeverRequired,
  ...other
}) => {
  const { layoutProps } = detachLayoutProps(other);

  const mapReviewStrategy: Record<
    RequirementReviewStrategy,
    (WSPillProps & { helperText: string }) | undefined
  > = {
    [RequirementReviewStrategy.AlwaysRequired]: {
      theme: "blue",
      text: "Approvals on",
      icon: "check-circle",
      helperText: REVIEW_STRATEGY_ALWAYS_REQUIRED_COPY
    },
    [RequirementReviewStrategy.OnFail]: {
      theme: "blue",
      text: "Approvals on",
      icon: "alert-circle",
      helperText: REVIEW_STRATEGY_ON_FAIL_COPY
    },
    [RequirementReviewStrategy.NeverRequired]: {
      theme: "neutral",
      text: "Approvals off",
      icon: "minus-circle",
      helperText: REVIEW_STRATEGY_NEVER_REQUIRED_COPY
    }
  };

  const props = mapReviewStrategy[reviewStrategy];

  if (!props) {
    return null;
  }

  return (
    <WSElement {...layoutProps}>
      <WSSectionToolbar title="Approvals" />
      <WSPanel mt="M">
        <WSList gap="L">
          <WSText.ParagraphSm color="gray500">Approvals</WSText.ParagraphSm>
          <WSElement>
            <WSPill {...props} />
            <WSText.ParagraphXs color="gray500" mt="S">
              {props.helperText}
            </WSText.ParagraphXs>
          </WSElement>
        </WSList>
      </WSPanel>
    </WSElement>
  );
};
